import React from 'react'
import Select, { components } from 'react-select'
import getDayKey from '../../functions/getDayKey'
import getMomentDateObj from '../../functions/getMomentDateObj'
import getShowtimeKey from '../../functions/getShowtimeKey'
import getTranslation from '../../functions/getTranslation'
import { SINGLECINEMA } from '../../constants/multiCinemaModes'
import checkForQuickTicketSelectOptions from '../../functions/checkForQuickTicketSelectOptions'


const getSortedCinemasObjects = (cinemaPk, cinemas) => {
    const sortedTheatres = cinemaPk.sort(function(a, b) {
        const cinemaA = cinemas[a]
        const cinemaB = cinemas[b]

        const aName = cinemaA.nameDisplay
        const bName = cinemaB.nameDisplay
        
        return bName > aName ? -1 : bName < aName ? 1 : 0
    })

    return sortedTheatres
}

const BuyTicketCinemaList = ({movies, translation, dateNow, moviesOrder, state, cinemas, cinemaPkList, changeCinema, selectSettings}) => {
    const { timezone } = translation
    const { currentMovieID, currentMovieDate, currentMovieShowtime, currentCinemaOption } = state
 
    let options = []
    let cinemasArray = []

    const Placeholder = (props) => {
        return (
            <components.Placeholder {...props}/>
        );
    };

    const onChange = (cinema) => {
        if(!cinema) {
            const value = ''
            const option = ''
            changeCinema(value, option)
        } else {
            const {value} = cinema
            const option = cinema
            changeCinema(value, option)
        }
    }

    cinemaPkList.map(cinemaPk => {
        const cinema = cinemas[cinemaPk]
        if(cinema && cinema.scope.type === SINGLECINEMA && !_.contains(cinemasArray, cinemaPk)) {
            cinemasArray.push(cinemaPk)
        }
    })
    
    let sortedCinemas = getSortedCinemasObjects(cinemasArray, cinemas)

    if(currentMovieID !== '') {
        sortedCinemas = _.filter(sortedCinemas, cinemaPk => {
            const currentMoviePerformances = movies[currentMovieID].performances
            const filteredPerformances = _.filter(currentMoviePerformances, performance => {
                let hasAttribute = checkForQuickTicketSelectOptions(currentMovieDate, currentMovieShowtime, cinemaPk, performance, dateNow, timezone)
                const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
                
                if(!_.contains(hasAttribute, 'false')) {
                    return dateNow.isBefore(performanceDate)
                }
            })

            return filteredPerformances.length !== 0
        })
    } else {
        sortedCinemas = _.filter(sortedCinemas, cinemaPk => {
            const filteredMovies = _.filter(moviesOrder, movieID => {
                const currentMoviePerformances = movies[movieID].performances
                const filteredPerformances = _.filter(currentMoviePerformances, performance => {
                    let hasAttribute = checkForQuickTicketSelectOptions(currentMovieDate, currentMovieShowtime, cinemaPk, performance, dateNow, timezone)
                    const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
                    
                    if(!_.contains(hasAttribute, 'false')) {
                        return dateNow.isBefore(performanceDate)
                    }
                })

                return filteredPerformances.length !== 0
            })

            return filteredMovies.length !== 0
        })
    }

    sortedCinemas.map((value) => {
        const cinema = cinemas[value]
        const label = cinema.nameDisplay

        options.push({value,label})
    })

    return <Select {...selectSettings}
                options={options}
                components={{ Placeholder }}
                placeholder={getTranslation('selectCinema', translation)}
                value={currentCinemaOption}
                onChange={(value) => onChange(value)}
                menuPlacement={'top'}
            />
} 

export default BuyTicketCinemaList